export default __webpack_public_path__ + "static/media/harvey2.5ca89a68.jpg";